var _rect, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18696_43733",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18696_43733)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V24H32V0H0Z",
    fill: "#F7FCFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_18696_43733",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V24H32V0H0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_18696_43733)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0002 18.2194C19.2029 18.2194 21.7993 15.4621 21.7993 12.0609C21.7993 8.65961 19.2029 5.90234 16.0002 5.90234C12.7975 5.90234 10.2012 8.65961 10.2012 12.0609C10.2012 15.4621 12.7975 18.2194 16.0002 18.2194Z",
    fill: "#3D58DB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_18696_43733",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 5,
    width: 12,
    height: 14
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0002 18.2194C19.2029 18.2194 21.7993 15.4621 21.7993 12.0609C21.7993 8.65961 19.2029 5.90234 16.0002 5.90234C12.7975 5.90234 10.2012 8.65961 10.2012 12.0609C10.2012 15.4621 12.7975 18.2194 16.0002 18.2194Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_18696_43733)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0019 12.5325C22.0019 12.5325 21.6764 9.62856 19.2657 9.47091C16.8551 9.31327 16.2051 11.6005 16.066 12.2065C15.9269 12.8124 15.5748 14.4289 13.0366 14.4289C10.4985 14.4289 10.2695 10.3185 10.2695 10.3185V5.47168H22.0019V12.5325Z",
    fill: "#E31D1C"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29983 2.05176L8.21479 2.87928L3.97453 7.83119L3.05957 7.00366L7.29983 2.05176ZM8.80882 3.39092L9.72378 4.21844L5.63552 9.09861L4.72056 8.27108L8.80882 3.39092ZM11.2259 5.5741L10.3109 4.74657L6.21127 9.66377L7.12623 10.4913L11.2259 5.5741Z",
    fill: "#272727"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3644 1.70508L24.4493 2.52951L26.0367 4.39234L26.9518 3.56791L25.3644 1.70508ZM28.186 5.13172L27.2709 5.95615L28.8583 7.81898L29.7734 6.99455L28.186 5.13172ZM21.4287 5.2127L22.3438 4.38827L23.9312 6.2511L23.0161 7.07553L21.4287 5.2127ZM25.1654 7.8149L24.2503 8.63933L25.8377 10.5022L26.7528 9.67774L25.1654 7.8149ZM22.9962 3.83109L23.9114 3.00666L28.33 8.38752L27.4148 9.21195L22.9962 3.83109Z",
    fill: "#272727"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0558 14.2427L25.1329 13.415L23.5321 15.2851L24.455 16.1128L26.0558 14.2427ZM23.3645 17.5337L22.4416 16.7061L20.8408 18.5762L21.7637 19.4038L23.3645 17.5337ZM28.0473 16.0324L28.9702 16.8601L27.3694 18.7302L26.4466 17.9025L28.0473 16.0324ZM26.4105 20.2274L25.4876 19.3997L23.8869 21.2698L24.8097 22.0975L26.4105 20.2274ZM23.9674 17.9776L24.8902 18.8053L23.2193 20.8022L22.2964 19.9746L23.9674 17.9776ZM27.6317 15.4778L26.7088 14.6502L25.0379 16.6471L25.9607 17.4747L27.6317 15.4778Z",
    fill: "#272727"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.40743 14.8898L7.32263 14.0645L11.4072 18.7449L10.492 19.5702L6.40743 14.8898ZM7.36022 18.9835L8.27543 18.1581L10.0007 20.0537L9.08553 20.879L7.36022 18.9835ZM4.31029 16.6907L3.39508 17.516L7.50088 22.2594L8.41609 21.4341L4.31029 16.6907ZM4.96147 16.1521L5.87668 15.3268L7.37235 17.0806L6.45714 17.906L4.96147 16.1521Z",
    fill: "#272727"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKo);
export default __webpack_public_path__ + "static/media/ko.e99fe0d8c142cc93a3a22eab264a0774.svg";
export { ForwardRef as ReactComponent };